<ion-row *ngIf="!showNoAnlegg">
  <ion-col>
    <ion-row>
      <ion-col
        size="12"
        offset="0"
        size-sm="8"
        offset-sm="2"
        size-lg="8"
        offset-lg="2"
        size-xl="6"
        offset-xl="3"
      >
        <div class="abouttext text-center">
          <div *ngIf="activeGraphDescription">
            <ion-button (click)="openAlert()">
              {{ activeGraphDescription.title }}
              <ion-icon
                name="information-circle-outline"
                class="ml-2 cursor-pointer"
              ></ion-icon>
            </ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
